import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import useNotifications from "./useNotifications";

const useActionRequest = ({ action, redirect, successMessage, errorMessage }) => {
  const dispatch = useDispatch();
  const { ok, ko } = useNotifications();
  const intl = useIntl();
  const history = useHistory();

  return async params => {
    const response = await dispatch(action(params));

    if (response.error) {
      if (errorMessage !== false) {
        ko(
          errorMessage ||
            intl.formatMessage({
              defaultMessage: "Operation failed",
              id: "Hooks.ActionRequest.OperationFailed"
            })
        );
      }
    } else {
      if (successMessage !== false) {
        ok(
          successMessage ||
            intl.formatMessage({
              defaultMessage: "Operation succedeed",
              id: "Hooks.ActionRequest.OperationSuccedeed"
            })
        );
      }
      if (redirect) {
        history.push(redirect);
      }
    }
    return response;
  };
};

export default useActionRequest;
